// extracted by mini-css-extract-plugin
export default {"item":"j7O88P","itemVertical":"Lw9uWg","imgWrapper":"eQAQ7A","verticalWrap":"ret0HA","img":"QsZFZo","vertical":"I6fLBY","mobile":"JPeQOF","title":"C37gPb"};